export default __webpack_public_path__ + "assets/images/0c52a40148017686ee94aa154f0af811.png";